import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "tags-box"
};
const _hoisted_2 = {
  class: "dropdown_box"
};
const _hoisted_3 = {
  class: "el-dropdown-link"
};
const _hoisted_4 = {
  class: "f_14"
};
const _hoisted_5 = {
  class: "el-dropdown-link"
};
const _hoisted_6 = {
  class: "f_14"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createBlock(_component_el_row, {
    class: "header-container"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 20,
      class: "tags-container"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: "left-menu-collapse",
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.changeCollapse && _ctx.changeCollapse(...args))
      }, [_createElementVNode("i", {
        class: _normalizeClass(_ctx.isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold')
      }, null, 2)]), _createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, idx) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          key: idx,
          "disable-transitions": false,
          onClick: $event => $options.handleClick(tag),
          onClose: $event => $options.handleCloseTag(idx, _ctx.tags),
          closable: tag.name !== 'Index' && tag.name !== 'ProductHomelist',
          class: _normalizeClass($data.fullPath === tag.fullPath ? 'tag active' : 'tag')
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(tag.meta.title), 1)]),
          _: 2
        }, 1032, ["onClick", "onClose", "closable", "class"]);
      }), 128))])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4,
      class: "text-c p-t-10"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_ctx.isShow ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              divided: "",
              key: index,
              onClick: $event => $options.changeLanguage(item)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
              _: 2
            }, 1032, ["onClick"]);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString($data.language), 1), _cache[1] || (_cache[1] = _createElementVNode("i", {
          class: "el-icon-arrow-down el-icon--right"
        }, null, -1))])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_dropdown, {
        "hide-on-click": false
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: $options.handleNavigatorPersonCenter
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("个人资料")])),
            _: 1,
            __: [3]
          }, 8, ["onClick"]), _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: $options.handleSigninOut
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("i", {
              class: "el-icon-switch-button"
            }, null, -1), _createTextVNode(" 退出 ")])),
            _: 1,
            __: [4]
          }, 8, ["onClick"])]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userInfo.staff_name), 1), _cache[2] || (_cache[2] = _createElementVNode("i", {
          class: "el-icon-arrow-down el-icon--right"
        }, null, -1))])]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  });
}